var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 88,
    viewBox: "0 0 103 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5299 61.6602L88.1156 40.1395C91.2243 37.0402 92.7786 35.4905 93.5973 33.5199C94.416 31.5494 94.416 29.3578 94.416 24.9748V22.8809C94.416 16.141 94.416 12.771 92.3159 10.6772C90.2157 8.58337 86.8356 8.58337 80.0753 8.58337H77.9752C73.5788 8.58337 71.3807 8.58337 69.4041 9.39962C67.4276 10.2159 65.8732 11.7655 62.7646 14.8648L41.1789 36.3855C37.5464 40.007 35.294 42.2526 34.4219 44.4215C34.1463 45.1068 34.0085 45.7844 34.0085 46.4954C34.0085 49.4565 36.3986 51.8394 41.1789 56.6053L41.8213 57.2458L49.3472 49.6077C50.4205 48.5184 52.1736 48.5055 53.2629 49.5787C54.3522 50.652 54.3652 52.4051 53.2919 53.4944L45.7431 61.1557L46.2491 61.6602C51.0293 66.426 53.4194 68.8089 56.3895 68.8089C57.0457 68.8089 57.6736 68.6926 58.3053 68.4599C60.5324 67.6396 62.8059 65.373 66.5299 61.6602ZM76.6707 36.3871C73.8705 39.1789 69.3305 39.1789 66.5303 36.3871C63.7301 33.5953 63.7301 29.069 66.5303 26.2772C69.3305 23.4855 73.8705 23.4855 76.6707 26.2772C79.471 29.069 79.471 33.5953 76.6707 36.3871Z",
    fill: "url(#paint0_linear_1_136)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9048 53.566C13.1762 54.8389 13.1749 56.9014 11.902 58.1728L11.234 58.8399C10.6634 59.4098 10.6634 60.3321 11.234 60.902C11.8068 61.4741 12.7371 61.4741 13.3099 60.902L20.6577 53.5632C21.9306 52.2918 23.9932 52.2931 25.2646 53.566C26.5359 54.8389 26.5347 56.9014 25.2617 58.1728L17.9139 65.5116C14.7975 68.6242 9.7464 68.6242 6.62998 65.5116C3.51138 62.3968 3.51137 57.3451 6.62998 54.2303L7.29797 53.5632C8.57089 52.2918 10.6334 52.2931 11.9048 53.566ZM31.3165 71.6535C32.5744 72.9397 32.5514 75.0022 31.2652 76.26L23.8399 83.5218C22.5537 84.7797 20.4913 84.7568 19.2333 83.4706C17.9754 82.1844 17.9984 80.122 19.2846 78.8641L26.7099 71.6023C27.9961 70.3444 30.0586 70.3673 31.3165 71.6535ZM49.2725 77.7566C50.5439 79.0295 50.5426 81.092 49.2697 82.3634L41.9218 89.7022C41.3512 90.2721 41.3512 91.1945 41.9218 91.7643C42.4946 92.3364 43.4249 92.3364 43.9977 91.7643L44.6656 91.0972C45.9386 89.8258 48.0011 89.827 49.2725 91.1C50.5439 92.3729 50.5426 94.4354 49.2697 95.7067L48.6017 96.3739C45.4853 99.4865 40.4342 99.4865 37.3178 96.3739C34.1992 93.2591 34.1992 88.2074 37.3178 85.0926L44.6656 77.7538C45.9386 76.4824 48.0011 76.4837 49.2725 77.7566Z",
    fill: "url(#paint1_linear_1_136)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5492 23.2147L37.1603 32.5753C35.4345 34.2958 33.8514 35.8741 32.6012 37.3008C31.7984 38.217 30.996 39.2198 30.3164 40.3279L30.2249 40.2367C30.0513 40.0635 29.9644 39.9769 29.8772 39.8923C28.2453 38.3089 26.3257 37.0499 24.2212 36.1829C24.1087 36.1365 23.9945 36.0913 23.7663 36.0009L22.3683 35.4469C20.4746 34.6966 19.9699 32.2586 21.4109 30.822C25.5465 26.6989 30.5119 21.7486 32.9083 20.7543C35.0216 19.8775 37.3046 19.5857 39.5065 19.9111C41.5239 20.2093 43.4324 21.2456 46.5492 23.2147Z",
    fill: "url(#paint2_linear_1_136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5807 72.5007C63.3373 73.2685 63.8398 73.811 64.2939 74.3904C64.8933 75.1553 65.4293 75.9676 65.8964 76.8192C66.4223 77.7779 66.8305 78.802 67.647 80.8502C68.3117 82.5176 70.5199 82.9584 71.8024 81.6796L72.1127 81.3703C76.2482 77.2471 81.2135 72.2967 82.2108 69.9075C83.0903 67.8005 83.3829 65.5244 83.0566 63.3292C82.7575 61.3181 81.7184 59.4156 79.7438 56.3089L70.3235 65.7008C68.5587 67.4604 66.9404 69.0739 65.4768 70.3379C64.5998 71.0953 63.6402 71.8524 62.5807 72.5007Z",
    fill: "url(#paint3_linear_1_136)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9881 62.501C34.2602 61.2288 34.2602 59.1663 32.9881 57.8942C31.716 56.622 29.6534 56.622 28.3813 57.8942L19.1868 67.0886C17.9146 68.3607 17.9146 70.4232 19.1868 71.6954C20.4589 72.9675 22.5215 72.9675 23.7936 71.6954L32.9881 62.501Z",
    fill: "url(#paint4_linear_1_136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0441 74.5421C46.3162 73.27 46.3162 71.2074 45.0441 69.9353C43.7719 68.6632 41.7094 68.6632 40.4372 69.9353L31.3056 79.0668C30.0334 80.339 30.0334 82.4015 31.3056 83.6736C32.5777 84.9458 34.6403 84.9458 35.9124 83.6736L45.0441 74.5421Z",
    fill: "url(#paint5_linear_1_136)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_136",
    x1: 49.3535,
    y1: 8.58337,
    x2: 49.3535,
    y2: 98.7084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A380FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_136",
    x1: 49.3535,
    y1: 8.58337,
    x2: 49.3535,
    y2: 98.7084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A380FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_136",
    x1: 51.8829,
    y1: 19.7819,
    x2: 51.8829,
    y2: 82.4205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A380FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_136",
    x1: 51.8829,
    y1: 19.7819,
    x2: 51.8829,
    y2: 82.4205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A380FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_136",
    x1: 32.1154,
    y1: 56.9401,
    x2: 32.1154,
    y2: 84.6277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A380FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_136",
    x1: 32.1154,
    y1: 56.9401,
    x2: 32.1154,
    y2: 84.6277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A380FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290781"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastImg);
export default __webpack_public_path__ + "static/media/FastImg.fc60b3624326db5830c2142841ff0840.svg";
export { ForwardRef as ReactComponent };